import { type LoaderFunctionArgs } from "react-router";

import {
  DashboardAgentsDocumentsDetailsDocument,
  type DashboardAgentsDocumentsDetailsQuery,
  type DashboardAgentsDocumentsDetailsQueryVariables,
} from "@app_schema";

import { client } from "@application/config/apollo";

export const DASHBOARD_AGENTS_DOCUMENTS_DETAILS_LOADER = async (
  props: LoaderFunctionArgs,
) => {
  const { id: agentID, documentID } = props.params;
  if (!agentID) throw new Error("undefined agentID");
  if (!documentID) throw new Error("undefined documentID");

  const { data } = await client.query<
    DashboardAgentsDocumentsDetailsQuery,
    DashboardAgentsDocumentsDetailsQueryVariables
  >({
    query: DashboardAgentsDocumentsDetailsDocument,
    variables: {
      agentID,
      documentID,
    },
  });

  return data;
};
